import { configureStore } from '@reduxjs/toolkit';
import authSlice from './authSlice';
import kitDataSlice from './kitDataSlice';
import paymentSlice from './paymentSlice';
import adminSlice from './adminSlice';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    kitData: kitDataSlice,
    payment: paymentSlice,
    admin: adminSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
